<template>
    <div>
        <app-template>
            <div class="flex items-center justify-between mb-6">
                <h2 class="text-xl font-bold">
                    <i class="fas fa-cog mr-2"></i>
                    Configuration des messages programmés
                </h2>
            </div>
            <div class="overflow-x-auto">
                <table class="divide-y divide-gray-200">
                    <thead class="bg-gray-50">
                        <tr>
                            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Message</th>
                            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Type d'envoi</th>
                        </tr>
                    </thead>
                    <tbody class="bg-white divide-y divide-gray-200">
                        <tr v-for="config in configs" :key="config.id" class="hover:bg-gray-50">
                            <td class="px-6 py-4 text-sm text-gray-900 w-[75%]">{{ descriptions[config.key] }}</td>
                            <td class="px-6 py-4 text-sm text-gray-900 w-[25%]">
                                <div>
                                    <template v-if="loadingUpdate[config.key]">
                                        <svg class="animate-spin h-5 w-5 text-gray-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                        </svg>
                                    </template>
                                    <template v-if="!loadingUpdate[config.key]">
                                        <select @change="changeConfig(config)" v-model="config.type" class="border border-gray-300 rounded-md p-2 text-xs focus:outline-none">
                                            <option value="sms">SMS</option>
                                            <option value="email">Email</option>
                                        </select>
                                    </template>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </app-template>
    </div>
</template>

<script>
export default {
    data() {
        return {
            configs: [],
            descriptions: {
                'next_entretien': 'Message envoyé au client pour lui rappeler son prochain entretien, planifié 1 an après le dernier entretien.',
                'avis_google': 'Message envoyé au client après une intervention pour lui demander de laisser un avis sur Google. A condition que votre url google soit paramétrée dans les paramètres de votre société.',
                'annonce_intervention': 'Message envoyé au client pour lui annoncer une intervention planifiée.',
                'rappel_intervention': 'Message envoyé au client pour lui rappeler une intervention planifiée, 24h avant l\'intervention.',
            },

            loadingUpdate: {
                'next_entretien': false,
                'avis_google': false,
                'annonce_intervention': false,
                'rappel_intervention': false
            }
        }
    },
    methods: {
        async getConfigs() {
            let response = await this.$request.get('/config-message');
            this.configs = response;
        },

        async changeConfig(config) {
            this.loadingUpdate[config.key] = true;
            let response = await this.$request.post('/config-message/update', {
                key: config.key,
                type: config.type
            });
            this.loadingUpdate[config.key] = false
        }
    },
    mounted() {
        this.getConfigs();
    }
}
</script>

<style lang="scss" scoped>

</style>